export const WORLD_CUP_POLLA_URL = 'https://polla.coonaltragas.com/';

export const WORLD_CUP_POLLA_LABEL = 'Polla Mundialista FIFA 2026';

export const WORLD_CUP_POLLA_SHORT_LABEL = 'Polla Mundialista';
